module.exports = "<div class=\"footer\">  \r\n  <div>\r\n    <strong>Copyright</strong> We Fly Kites &copy; {{ currentYear }}\r\n</div>\r\n"